module.exports = require('./helpers/bundle-url').getBundleURL('bgzEL') + "logo-dark.eefe0b7f.svg";